<div class="content">
  <rt-requisitions-activities-container></rt-requisitions-activities-container>
</div>
